import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export function AcervoTeaserOverlay({ onSwitch }: { onSwitch: () => void }) {
  const { t } = useTranslation();

  return (
    <div
      data-testid="acervo-teaser"
      className="mx-auto max-w-2xl rounded-2xl border border-border bg-card p-5 text-center shadow-sm"
    >
      <h2 className="text-lg font-semibold tracking-tight">
        {t('communityLibrary.teaserTitle')}
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
        {t('communityLibrary.teaserBody')}
      </p>
      <Button
        type="button"
        className="mt-4"
        onClick={onSwitch}
      >
        {t('account.switchToClippingChannels.cta')}
      </Button>
    </div>
  );
}
